// Aba "Telegram" — pareia conta do usuário com bot do Dwight no Telegram
// (gera token de pareamento + recebe webhook).
import { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Card, Button, Alert, Typography, App as AntApp,
} from 'antd';
import { API_URL } from '../../config';
import { getToken } from '../../utils/auth';
import { fmtDateTime } from './utils';

const { Title, Text } = Typography;

export default function TelegramTab() {
  const { message, modal } = AntApp.useApp();
  const [vinculos, setVinculos] = useState<any[]>([]);
  const [info, setInfo] = useState<{ username: string | null }>({ username: null });
  const [loading, setLoading] = useState(true);
  const [pareamento, setPareamento] = useState<any | null>(null);
  const [erro, setErro] = useState<string | null>(null);

  useEffect(() => { carregar(); }, []);
  async function carregar() {
    setLoading(true);
    try {
      const token = await getToken();
      const [vRes, iRes] = await Promise.all([
        axios.get(`${API_URL}/agentes/telegram/vinculo`, { headers: { Authorization: token } }),
        axios.get(`${API_URL}/agentes/telegram/info`, { headers: { Authorization: token } }).catch(() => null),
      ]);
      const v = vRes.data.body ? JSON.parse(vRes.data.body) : vRes.data;
      const i = iRes ? (iRes.data.body ? JSON.parse(iRes.data.body) : iRes.data) : { username: null };
      setVinculos(Array.isArray(v) ? v : []);
      setInfo(i || { username: null });
    } catch (e: any) {
      setErro(e.response?.data?.error || e.message);
    } finally { setLoading(false); }
  }

  async function gerarToken() {
    try {
      const token = await getToken();
      const r = await axios.post(`${API_URL}/agentes/telegram/pareamento`, {},
        { headers: { Authorization: token } });
      const data = r.data.body ? JSON.parse(r.data.body) : r.data;
      setPareamento(data);
    } catch (e: any) {
      setErro(e.response?.data?.error || e.message);
    }
  }

  function desvincular() {
    modal.confirm({
      title: 'Desvincular Telegram?', content: 'Você precisará parear novamente.',
      okText: 'Desvincular', cancelText: 'Cancelar', okButtonProps: { danger: true },
      onOk: async () => {
        const token = await getToken();
        await axios.delete(`${API_URL}/agentes/telegram/vinculo`, { headers: { Authorization: token } });
        setVinculos([]);
        message.success('Desvinculado.');
      },
    });
  }

  const botUser = info.username || pareamento?.bot_username;
  const linkInicio = botUser && pareamento ? `https://t.me/${botUser}?start=${pareamento.token}` : null;

  return (
    <div>
      {erro && <Alert type="error" message={erro} showIcon closable onClose={() => setErro(null)} style={{ marginBottom: 10 }} />}

      {!botUser && (
        <Alert type="warning" showIcon style={{ marginBottom: 14 }}
          message={<Text style={{ fontSize: 12 }}>
            <strong>Bot do Telegram não configurado.</strong> Admin precisa criar via @BotFather e configurar token na Lambda <code>telegram-bridge</code>.
          </Text>} />
      )}

      {vinculos.length > 0 ? (
        <Card size="small" style={{ background: '#E8F5EE', borderColor: '#0a7f4a' }}>
          <Text strong style={{ color: '#0a7f4a', fontSize: 13 }}>✅ Telegram pareado</Text>
          {vinculos.map(v => (
            <div key={v.telegram_user_id} style={{ marginTop: 8, fontSize: 12 }}>
              {v.telegram_username && <div>@{v.telegram_username}</div>}
              {v.telegram_nome && <Text type="secondary">{v.telegram_nome}</Text>}
              <div><Text type="secondary" style={{ fontSize: 10 }}>
                Pareado em {fmtDateTime(v.criado_em)}
                {v.ultima_interacao && ` · Última msg: ${fmtDateTime(v.ultima_interacao)}`}
              </Text></div>
            </div>
          ))}
          <Button danger size="small" style={{ marginTop: 10 }} onClick={desvincular}>Desvincular</Button>
        </Card>
      ) : (
        <div>
          <Title level={5} style={{ color: '#020D7F' }}>Como parear seu Telegram com o Dwight</Title>
          <ol style={{ fontSize: 12, lineHeight: 1.7 }}>
            <li>Clique em <strong>Gerar token de pareamento</strong>.</li>
            <li>{botUser ? <>Abra o Telegram e procure por <strong>@{botUser}</strong>.</> : <>Quando o bot estiver configurado, abra-o.</>}</li>
            <li>Mande: <Text code>/start SEU_TOKEN</Text></li>
            <li>Pronto.</li>
          </ol>

          {!pareamento ? (
            <Button type="primary" disabled={!botUser} onClick={gerarToken}>
              Gerar token de pareamento
            </Button>
          ) : (
            <Card size="small" style={{ marginTop: 12, background: '#FAFBFF' }}>
              <Text type="secondary" style={{ fontSize: 11 }}>Token (válido 10 min):</Text>
              <div style={{ fontSize: 22, fontFamily: 'monospace', fontWeight: 700, color: '#020D7F', letterSpacing: '0.1em', margin: '6px 0' }}>
                {pareamento.token}
              </div>
              {linkInicio && (
                <a href={linkInicio} target="_blank" rel="noopener noreferrer">
                  <Button type="primary" style={{ background: '#0088cc', borderColor: '#0088cc' }}>
                    📱 Abrir Telegram e parear
                  </Button>
                </a>
              )}
              <div style={{ marginTop: 8 }}>
                <Text type="secondary" style={{ fontSize: 11 }}>
                  Ou em <strong>@{botUser || 'seu_bot'}</strong>: <Text code>/start {pareamento.token}</Text>
                </Text>
              </div>
              <Button size="small" style={{ marginTop: 10 }} onClick={() => { setPareamento(null); carregar(); }}>
                Já pareei (atualizar)
              </Button>
            </Card>
          )}
        </div>
      )}

      {loading && <Text type="secondary" style={{ fontSize: 11 }}>Carregando...</Text>}
    </div>
  );
}
